<script>
	export default {
		props: {
			data: {
				type: Array,
				required: true
			}
		},
		methods: {
			deleteNotification(item) {
				this.$emit('deleteNotification', item);
			},
			notificacionVista(item) {
				//console.log("hola");
				this.$emit('notificacionVista', item);
				//item.vista = true;
			}
		},
	}
</script>
<template>
	<ul class="list-group list-group-flush overflow-notificaciones">
		<li
			v-for="item in data" :key="item.id"
			class="list-group-item list-group-item-action"
			:class="item.vista ? 'list-notificacion-vista' : '' "
		>
			<div class="d-flex">
				<div class="flex-grow-1">
					<router-link 
						:to="item.url"
						@click.native="notificacionVista(item)"
						class="d-flex align-items-center"
					>
						<div class="flex-shrink-0">
							<img 
								width="48"
								height="48"
								class="img-object-cover rounded-circle"
								:src="item.imagen"
							>
						</div>
						<div class="flex-grow-1 ms-3">
							<p class="d-grid text-secondary mb-0">
								<strong class="ellipsis-custom">
								{{ item.nombre_modulo }}
								</strong>
								<span class="text-secondary text-opacity-75 ellipsis-custom">
									{{ item.texto }}
								</span>
							</p>
						</div>
					</router-link>
				</div>
				<div class="d-flex align-items-center flex-shrink-0 ms-3">
					<a 
						@click="deleteNotification(item)"
						href="javascript:"
						class="fs-4 color-main"
						>
						<font-awesome-icon icon="fa-solid fa-trash-can"></font-awesome-icon>
					</a>
				</div>
			</div>
		</li>
	</ul>
</template>